import { Button } from '@/components/ui/Button';

export interface UserSaveFooterProps {
  saving: boolean;
  label?: string;
  onCancel: () => void;
}

/**
 * Shared footer for the tabs that edit the user record. Information and Access
 * share one form state, so either Save writes the whole record.
 */
export function UserSaveFooter({
  saving,
  label = 'Save user',
  onCancel,
}: UserSaveFooterProps) {
  return (
    <div className="flex items-center justify-end gap-2">
      <Button id="admin.users.cancel" variant="ghost" type="button" onClick={onCancel}>
        Cancel
      </Button>
      <Button type="submit" disabled={saving}>
        {saving ? 'Saving…' : label}
      </Button>
    </div>
  );
}
